import { Slide } from 'pure-react-carousel';
import React from 'react';
import s from './slideStyles';
import Slide3 from './slide_3.svg';

export default ({ index }) => (
    <Slide className={s.slideWrapper} index={index}>
        <div className={s.imageWrapper}>
            <Slide3 />
        </div>
        <div className={s.textWrapper}>
            <p>
                The composition and combination of data, cognitive knowledge,
                processes, and AI components is customized to the specific task
                each building block is designed to do.
            </p>
            <p>
                <em>It can be any task or level of expertise.</em>
            </p>
        </div>
    </Slide>
);



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide3.component.js